function setUpSaveSearchLogin () {
  const saveSearchBtn = document.getElementById('vjs-save-search-button')
  if (!saveSearchBtn) return

  saveSearchBtn.addEventListener('click', () => {
    document.getElementById('vjs-login-modal-purpose').value = 'save-search'

    const oauthAndRegisterButtons = document.querySelectorAll('.vjs-oauth-button, .vjs-register-here-link')
    oauthAndRegisterButtons.forEach(registerButton => {
      const baseUrl = registerButton.href.split('?')[0]
      registerButton.href = baseUrl + '?login_purpose=save-search'
    })
  })
}

export default function setUpSaveSearch () {
  setUpSaveSearchLogin()
}
